// import React, { useRef } from "react";
// import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css";

// const CustomEditor = ({ data, onChange, onFocus, onBlur }) => {
//   const quillRef = useRef(null);

//   const modules = {
//     toolbar: [
//       [{ header: [false, 1, 2, 3] }], // Paragraph + headings
//       ["bold", "italic", "underline", "strike"],
//       ["blockquote", "code-block"],
//       [{ list: "ordered" }, { list: "bullet" }],
//       [{ indent: "-1" }, { indent: "+1" }],
//       ["link", "image", "clean"]
//     ]
//   };

//   const formats = [
//     "header",
//     "bold", "italic", "underline", "strike",
//     "blockquote", "code-block",
//     "list", "bullet",
//     "indent",
//     "link", "image"
//   ];

//   // Wrapper for CKEditor-style onChange
//   const handleChange = (content, delta, source, editor) => {
//     if (onChange) {
//       onChange({ target: { value: content } }, editor);
//     }
//   };

//   return (
//     <ReactQuill
//       ref={quillRef}
//       theme="snow"
//       value={data || ""}
//       onChange={handleChange}
//       onFocus={onFocus}
//       onBlur={onBlur}
//       modules={modules}
//       formats={formats}
//       placeholder="Type here..."
//     />
//   );
// };

// export default CustomEditor;




// import { CKEditor } from "@ckeditor/ckeditor5-react";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

// export default function CustomEditor({ data, onChange }) {
//   return (
//     <CKEditor
//       editor={ClassicEditor}
//       data={data}
//       onChange={(event, editor) => {
//         const value = editor.getData();

//         //  React-style fake event (same as before)
//         onChange({
//           target: {
//             value: value,
//           },
//         });
//       }}
//     />
//   );
// }



import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

function Base64UploadAdapter(editor) {
  editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
    return {
      upload: () =>
        loader.file.then(
          (file) =>
            new Promise((resolve) => {
              const reader = new FileReader();
              reader.onload = () => resolve({ default: reader.result });
              reader.readAsDataURL(file);
            })
        ),
    };
  };
}

export default function CustomEditor({ defaultValue, onChange }) {
  return (
    <CKEditor
      editor={ClassicEditor}
      data={defaultValue || "<p></p>"}   // ✅ only once
      config={{
        extraPlugins: [Base64UploadAdapter],
        toolbar: [
          "bold",
          "italic",
          "underline",
          "|",
          "bulletedList",
          "numberedList",
          "|",
          "insertTable",
          "imageUpload",
          "|",
          "undo",
          "redo",
        ],
      }}
      onChange={(event, editor) => {
        onChange(editor.getData()); // ✅ string only
      }}
    />
  );
}

